import React__default from 'react';
import classNames from 'classnames';
import { CartContext } from '../../../context/CartContext.esm.js';
import '../../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../../constants/analytics.esm.js';
import '../../../modals/content/index.esm.js';
import '../../../modals/content/default_validation_error.esm.js';
import '../../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import '../../../constants/api.esm.js';
import Info from '../../Info/Info.esm.js';
import { rereqInfoUrl } from '../../../utils/constants/urls.esm.js';
import styles from './RereqTooltip.module.esm.js';

var FVT_SPECIFIC_INFO = 'Adding reflex testing disqualifies the order as no charge family follow-up testing.';
var RereqTooltip = function (_a) {
    var className = _a.className;
    var meta = React__default.useContext(CartContext).meta;
    return (React__default.createElement(Info, { className: classNames(styles.rereqTooltip, className), content: React__default.createElement("div", { "data-testid": "rereq-tooltip-content" },
            "Depending on your patient\u2019s history, it may be appropriate to begin with a smaller panel and later expand your search. Invitae offers one re-requisition at no additional charge within 90 days for tests that fall within the same clinical area. Request a re-requisition now through reflex testing or wait until after you receive initial results.", " ".concat((meta === null || meta === void 0 ? void 0 : meta.fvtDetails) ? "".concat(FVT_SPECIFIC_INFO, " ") : ''),
            React__default.createElement("a", { href: rereqInfoUrl, rel: "noopener noreferrer", target: "_blank" }, "Learn more.")), tooltipClassName: styles.rereqTooltipCard }));
};

export { FVT_SPECIFIC_INFO, RereqTooltip as default };
//# sourceMappingURL=RereqTooltip.esm.js.map
